import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Truck } from 'lucide-react';
import { mpOrdersAPI } from '../../services/api';

const MAIN = { pending_payment: 'En attente de paiement', confirmed: 'Confirmée', processing: 'En préparation', partially_shipped: 'Partiellement expédiée', shipped: 'Expédiée', completed: 'Terminée', cancelled: 'Annulée', expired: 'Expirée' };

// Point d'entrée client vers ses commandes d'occasion (séparées des commandes de pièces neuves) — rien n'est affiché s'il n'en a aucune
export const MpOrdersList = () => {
  const [orders, setOrders] = useState([]);
  useEffect(() => { mpOrdersAPI.list().then((r) => setOrders(r.orders || [])).catch(() => {}); }, []);
  if (!orders.length) return null;
  return (
    <section className="bg-white rounded-lg shadow-sm p-4 mb-4" data-testid="mp-orders-list">
      <h2 className="text-base md:text-lg font-semibold text-gray-900 inline-flex items-center gap-2"><Truck size={16} className="text-orange-500" />Mes commandes de pièces d'occasion</h2>
      <p className="text-xs text-gray-500 mb-2">Pièces vendues par des professionnels partenaires : chaque vendeur expédie ses articles séparément.</p>
      <ul className="divide-y divide-gray-100">
        {orders.map((o) => <li key={o.id} className="py-2 flex flex-wrap items-center justify-between gap-2 text-sm" data-testid={`mp-orders-row-${o.id}`}>
          <Link to={`/mes-commandes/occasion/${o.id}`} className="font-medium text-gray-900 hover:text-orange-600" data-testid={`mp-orders-open-${o.id}`}>{o.order_number}</Link>
          <span className="text-xs text-gray-500">{new Date(o.created_at).toLocaleDateString('fr-FR')} · {(o.sub_order_ids || []).length} vendeur(s) · {Number(o.total_estimated || 0).toFixed(2)} € estimés</span>
          <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold">{MAIN[o.status] || o.status}</span>
        </li>)}
      </ul>
    </section>
  );
};
